import React, { useState, Fragment, useEffect, useCallback } from 'react';
import { Table, Image, Col, Modal, Row } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { FormControl, Select, InputLabel } from '@material-ui/core';
import { withRouter, useHistory } from 'react-router-dom';
import LeftSideNavigation from '../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation';
import HomeReusableTopBarNavigation from '../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation';
import { Button } from 'react-bootstrap';
import SelectFilter from '../../../../reusableComponents/selectFilter';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CSVDownloader from '../../../../reusableComponents/csvDownload/csvDownload';
import styled, { keyframes } from 'styled-components';
import { zoomIn } from 'react-animations';
import isEmpty from '../../../../../store/validation/is-Empty';
import {
  short_videos_get,
  short_videos_status_update,
} from '../../../../../store/actions/SuperAdminActions/adminShortVideosAction';
import { Toggle } from '../../../superAdminReusable/reusableSuperAdminButton/Toggle';
import SuperAdminDeleteShortvideo from './DeleteShortVideo';
import { Menu, MenuItem } from '@material-ui/core';
import BasicPagination from '../../../../Pagination/Pagination';
import Debounce from '../../../../../function/debounce';
import ReadMoreReact from 'read-more-react/dist/components/ReadMoreReact';
import { ListOfLikesView } from './ListOfLikesView';
import { ListOfSharesView } from './ListOfSharesView';
import ReadMore from '../../../../reusableComponents/ReadMore';
import Switch from 'react-switch';
import ShareLinkModal from '../../../../reusableComponents/ShareLinkModal';
import { webappUrl } from '../../../../../config/Keys';

const zoomAnimation = keyframes`${zoomIn}`;
const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

//filter options //

const ShortStatus = [
  { id: 0, title: 'All', value: 'null' },
  { id: 1, title: 'Active', value: true },
  { id: 2, title: 'In-Active', value: false },
];

const Actions = [
  { id: 0, title: 'All', value: 'null' },
  { id: 1, title: 'Experience Page', value: 'EXPERIENCE_BOOKING_PAGE' },
  { id: 2, title: 'Restaurant Page', value: 'RESTAURANT_PAGE' },
];

// sort //

const sortOptions = [
  { title: 'Sort by', disabled: true },
  {
    title: `Date & Time🠑`,
    disabled: false,
    value1: 'DATETIME',
    value2: 'ASC',
  },
  {
    title: 'Date & Time🠓',
    disabled: false,
    value1: 'DATETIME',
    value2: 'DSC',
  },
  { title: 'Likes Count🠑', disabled: false, value1: 'LIKES', value2: 'ASC' },
  { title: 'Likes Count🠓', disabled: false, value1: 'LIKES', value2: 'DSC' },
  { title: 'Views Count🠑', disabled: false, value1: 'VIEWS', value2: 'ASC' },
  { title: 'Views Count🠓', disabled: false, value1: 'VIEWS', value2: 'DSC' },
];
const SuperAdminShortVideoDashboard = (props) => {
  const history = useHistory();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [showFilter, setShowFilter] = useState(false);

  const [dateQuery, setDateQuery] = useState({});

  const DateForm = {
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  };

  const [state, setState] = useState({
    restaurant_type: '',
    request_type: 'All',
    showSearch: false,
  });

  const [filters, setFilter] = useState({
    search: '',
    statusBy: '',
    callToAction: '',
    sortBy: '',
    sortOrder: '',
    VideoStatus: 'All',
    page: 1,
    archive: false,
  });

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      handleBatchChange(1);
    }
  }, [
    dateQuery,
    filters.sortBy,
    filters.sortOrder,
    filters.search,
    filters.archive,
  ]);

  const handleShowFilter = () => {
    setShowFilter(!showFilter);
    if (state.showSearch) {
      setState({
        ...state,
        showSearch: !state.showSearch,
      });
    }
  };

  const handleShowsearch = () => {
    setState({
      ...state,
      showSearch: !state.showSearch,
    });
    if (showFilter) {
      setShowFilter(!showFilter);
    }
  };

  const onSearchChange = (e) => {
    setFilter({
      ...filters,
      search: e,
    });
  };

  const debounceOnChange = useCallback(Debounce(onSearchChange, 1000), []);

  const ApplyFilter = () => {
    setShowFilter(!showFilter);
    handleBatchChange(1);
  };

  const cancelClick = () => {
    setShowFilter(!showFilter);
    setFilter({
      ...filters,
      statusBy: null,
      callToAction: null,
    });
    getData(
      props.auth.user.accessToken,
      dateQuery.startDate === 'undefined' ? DateForm : dateQuery,
      { ...filters, statusBy: null, callToAction: null }
    );
  };

  const getData = (_token, datedata, filters) => {
    return props.short_videos_get(_token, datedata, filters);
  };

  const updateShortsStatus = async (id, status) => {
    const token = props.auth.user.accessToken;
    await props.short_videos_status_update(token, id, { status: !status });
    await getData(
      props.auth.user.accessToken,
      dateQuery.startDate === 'undefined' ? DateForm : dateQuery,
      filters
    );
  };

  const OnSuccessArchive = () => {
    getData(
      props.auth.user.accessToken,
      dateQuery.startDate === 'undefined' ? DateForm : dateQuery,
      filters
    );
  };

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    setFilter({ ...filters, page: pageNo });
    getData(
      props.auth.user.accessToken,
      dateQuery.startDate === 'undefined' ? DateForm : dateQuery,
      { ...filters, page: pageNo }
    );
  };

  const downloadData = {
    headers: [
      { label: 'Reels  \n location  ID', key: 'reelsId' },
      { label: 'Likes', key: 'likes' },
      { label: 'Shares', key: 'shares' },
      { label: 'Views', key: 'views' },
      { label: 'Restaurant Tagged', key: 'taggedRest' },
      { label: 'Experience Type/Experience ID', key: 'expTypeId' },
      { label: 'Description', key: 'description' },
      { label: 'Status', key: 'status' },
      { label: 'Uploaded By', key: 'uploadedBy' },
      { label: 'User ID', key: 'userId' },
      { label: 'Last Activity Date & Time', key: 'lastActivity' },
      { label: 'Call To Action', key: 'callToAction' },
      { label: 'Date & Time', key: 'dateTime' },
    ],
    data: props?.shortvideosdata?.records
      ? props?.shortvideosdata?.records?.map((ele) => {
          return {
            reelsId: `${ele?.restaurant?.city} \n ${ele?._id}`,
            likes: ele?.likes || 0,
            shares: ele?.shares || 0,
            views: ele?.views || 0,
            taggedRest: `${ele?.restaurant?.name || ''} \n ${
              ele?.restaurant?.area || ''
            } ${ele?.restaurant?._id || ''}`,
            expTypeId: `${ele?.experience?.subCategory?.title || ' '} \n ${
              ele?.experience?._id || 'N/A'
            }`,
            description: `${ele?.description || ''}`,
            status: ele?.status ? 'Active' : 'In-Active',
            uploadedBy: 'Super Admin',
            userId: 'n/a',
            lastActivity: `${moment(ele?.updatedAt).format(
              'Do MMM YY,'
            )} ${moment(ele?.updatedAt).format('hh:mm:A')}`,
            callToAction:
              ele?.callToAction == 'RESTAURANT_PAGE'
                ? 'Restaurant Page'
                : 'Experience Booking Page',
            dateTime: `${moment(ele?.createdAt).format('Do MMM YY,')} ${moment(
              ele?.createdAt
            ).format('hh:mm:A')}`,
          };
        })
      : [],
  };

  console.log(filters.archive, 'archiveeee');

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Short Videos Dashboard
                  <br />
                </div>
                <div className="col-6 text-right">
                  <button
                    type="button"
                    className="mr-4 px-5  btn addBtnRed f12-700"
                    style={{ color: '#EE3A23', padding: '0.7rem 0' }}
                    // onClick={this.onOpenModal}
                    onClick={() => history.push('/superadmin/short-videos/add')}
                  >
                    Add Short Video
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-4 d-flex align-items-center pl-0">
                  <Image
                    onClick={handleShowsearch}
                    alt="filter"
                    title="search"
                    width="80px"
                    src={require('../../../../../assets/images/iconButton/newsearchicon.svg')}
                  />
                  <div
                    className="f10-400"
                    align="center"
                    onClick={handleShowFilter}
                  >
                    <img
                      src={require('../../../../../assets/images/iconButton/filterbtn.svg')}
                      width="80px"
                    />
                    <br />
                  </div>
                  <Image
                    onClick={handleClick}
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    src={require('../../../../../assets/images/iconButton/sortbtn.svg')}
                    width="80px"
                  />
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    {sortOptions.map((ele, index) => {
                      return (
                        <MenuItem
                          value={ele.title}
                          key={index}
                          onClick={() => {
                            setFilter({
                              ...filters,
                              sortBy: ele.value1,
                              sortOrder: ele.value2,
                            });
                            handleClose();
                          }}
                          disabled={ele.disabled}
                        >
                          {ele.title}
                        </MenuItem>
                      );
                    })}
                  </Menu>
                  <CSVDownloader
                    filename={'Super Admin videos'}
                    headers={downloadData.headers}
                    data={downloadData.data}
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-5 d-flex justify-content-end align-items-center">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler} />
                  </div>
                </div>
              </div>
              {state.showSearch && (
                <div className="mb-3">
                  <ZoomDiv>
                    <>
                      <br />
                      <Form.Control
                        type="text"
                        placeholder="Search by Restaurant Tagged ,Description"
                        name="search"
                        // onChange={onSearchChange}
                        value={filters.search}
                        onChange={(e) => {
                          onSearchChange(e.target.value);
                          // debounceOnChange(e.target.value);
                        }}
                        className="amSearch"
                      />
                    </>
                  </ZoomDiv>
                </div>
              )}
              {showFilter && (
                <div className="col-12  mt-3">
                  <div className="enWhiteBox mt-3">
                    <Form className="my-1">
                      <Row>
                        <Col md={4}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Offer">
                                Status
                              </InputLabel>
                              <Select
                                value={filters.statusBy}
                                onChange={(e) => {
                                  setFilter({
                                    ...filters,
                                    statusBy: e.target.value,
                                  });
                                }}
                                label="status"
                                inputProps={{
                                  name: 'Offer',
                                  id: 'outlined-Location',
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {ShortStatus.map((data) => {
                                  return (
                                    <option value={data.value} key={data.id}>
                                      {data.title}
                                    </option>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Offer">
                                Call to Action
                              </InputLabel>
                              <Select
                                value={filters.callToAction}
                                onChange={(e) =>
                                  setFilter({
                                    ...filters,
                                    callToAction: e.target.value,
                                  })
                                }
                                label="Offer"
                                inputProps={{
                                  name: 'Offer',
                                  id: 'outlined-Location',
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {Actions.map((data) => {
                                  return (
                                    <option value={data.value} key={data.id}>
                                      {data.title}
                                    </option>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Col>
                        <div className="d-flex align-items-center">
                          <Button
                            variant="outline-secondary"
                            className="btn-lg mr-4 px-5"
                            onClick={cancelClick}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="danger"
                            className="btn-lg px-5"
                            onClick={ApplyFilter}
                          >
                            Apply filter
                          </Button>
                        </div>
                      </Col>
                    </Form>
                  </div>
                </div>
              )}
              <div className="Row mt-3">
                <div
                  onClick={(e) =>
                    setFilter({ ...filters, page: 1, archive: false })
                  }
                  className={`mr-4 px-0 text-grayLink f12-700 btn btn-link ${
                    filters.archive ? `` : 'active'
                  }`}
                >
                  Active Videos
                </div>
                <div
                  onClick={(e) =>
                    setFilter({ ...filters, page: 1, archive: true })
                  }
                  className={`mr-4 px-0 text-grayLink f12-700 btn btn-link   ${
                    filters.archive === true && `active`
                  }`}
                >
                  Archived Videos
                </div>
              </div>
              <hr className="p-0 m-0" />
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: '15%' }} className="f12-400">
                        Reels/
                        <br /> Location/
                        <br /> ID
                      </td>
                      <td style={{ width: '10%' }} className="f12-400">
                        Likes
                      </td>
                      <td style={{ width: '10%' }} className="f12-400">
                        Shares
                      </td>
                      <td style={{ width: '13%' }} className="f12-400">
                        Views
                      </td>
                      <td style={{ width: '15%' }} className="f12-400">
                        Restaurant
                        <br /> Tagged
                      </td>
                      <td style={{ width: '15%' }} className="f12-400">
                        Experience Type/
                        <br /> Experience ID
                      </td>
                      <td style={{ width: '15%' }} className="f12-400">
                        Description
                      </td>
                      <td style={{ width: '10%' }} className="f12-400">
                        Status
                      </td>
                    </tr>
                  </thead>
                  {props?.shortvideosdata?.records?.map((ele, index) => (
                    <TableBody
                      key={index}
                      data={ele}
                      // auth={props?.auth}
                      updateStatus={updateShortsStatus}
                      onArchive={OnSuccessArchive}
                    />
                  ))}
                </Table>
              </div>
              {props.shortvideosdata?.paginationInfo?.totalCount ? (
                <>
                  <BasicPagination
                    totalRecords={
                      props.shortvideosdata?.paginationInfo?.totalCount || 0
                    }
                    limit={10}
                    batch={filters.page}
                    onBatchChange={(e) => handleBatchChange(e)}
                  />
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

SuperAdminShortVideoDashboard.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  short_videos_get: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  shortvideosdata: state.superAdminShortVideos.shortVideos,
});

export default connect(mapStateToProps, {
  short_videos_get,
  short_videos_status_update,
})(withRouter(SuperAdminShortVideoDashboard));

const TableBody = (props) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);
  const history = useHistory();

  const handleToggle = () => {
    if (props.updateStatus && props.data) {
      props.updateStatus(props.data._id, props.data.status);
    }
  };
  return (
    <Fragment>
      <tbody className="w-100 super-admin-all-vendor-main-table-body">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css text-break">
                <tr onClick={showTr}>
                  <td style={{ width: '15%' }}>
                    <div className="text-break">
                      <Image
                        src={
                          !isEmpty(props.data?.thumbnailUrl)
                            ? props.data?.thumbnailUrl
                            : require('../../../../../assets/images/ActionImages/demoprofile.jpg')
                        }
                        alt={'video Logo'}
                        title={'video Logo'}
                        fluid
                        className="img-thumbnail h-auto w-50 mb-2"
                      />
                      <h5 className="font_16_m ">
                        {props?.data?.restaurant?.city || ''}
                      </h5>
                      <p className="f10-400 ">#{props?.data?._id}</p>
                    </div>
                  </td>
                  <td
                    style={{ width: '10%' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="f12-500">{props?.data?.likes || 0}</div>
                    <ListOfLikesView data={props?.data} auth={props?.auth} />
                  </td>
                  <td
                    style={{ width: '10%' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="f12-500">{props?.data?.shares || 0}</div>
                    <ListOfSharesView data={props?.data} auth={props?.auth} />
                  </td>
                  <td style={{ width: '13%' }}>
                    <div className="f12-500">{props?.data?.views || 0}</div>
                    <p className="text-grey">People Reached</p>
                  </td>
                  <td style={{ width: '15%' }}>
                    <div className="f12-500">
                      {props?.data?.restaurant?.name || ''}
                    </div>
                    <div className="f10-500">
                      {props?.data?.restaurant?.area || ''}
                    </div>
                    <div className="f10-500">
                      #{props?.data?.restaurant?._id || ''}
                    </div>
                  </td>
                  <td style={{ width: '15%' }}>
                    <div className="f12-500">
                      {props?.data?.experience?.subCategory?.title || ' '}
                    </div>
                    <div className="f10-500">
                      {props?.data?.experience?._id || 'N/A'}
                    </div>
                  </td>
                  <td
                    style={{ width: '15%' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="f12-500 text-grey" id="read-more-text">
                      {/* <ReadMoreReact
                        text={props?.data?.description || ""}
                        min={0}
                        ideal={
                          props?.data?.description?.length > 10
                            ? 10
                            : props?.data?.description?.length
                        }
                        max={
                          props?.data?.description &&
                          props?.data?.description?.length
                        }
                        readMoreText={"Read More"}
                      /> */}
                      <ReadMore
                        text={props?.data?.description || ''}
                        minLength={
                          props?.data?.description?.length < 50
                            ? props?.data?.description?.length
                            : 50
                        }
                        charLength={
                          props?.data?.description &&
                          props?.data?.description?.length
                        }
                      />
                    </div>
                  </td>
                  <td
                    style={{ width: '10%' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div>
                      <Toggle
                        checked={props?.data?.status}
                        toggleFunction={handleToggle}
                        disabled={props?.data?.archive}
                      />
                      {/* <Switch
                        onClick={(e) => {
                          if (!e) var e = window.event;
                          e.cancelBubble = true;
                          if (e.stopPropagation) e.stopPropagation();
                        }}
                        onChange={handleToggle}
                        checked={props?.data?.status}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={24}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={15}
                        width={41}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                        disabled={props?.data?.archive}
                      /> */}
                    </div>
                  </td>
                </tr>
                {TrDetail && (
                  <>
                    <tr className="sd_accordion_body pl-0">
                      <td style={{ width: '15%' }}>
                        <div className="f12-500 mb-3">Uploaded by</div>
                        <div className="f12-400 mt-2">
                          {props?.data?.uploadedBy || ''}
                        </div>
                      </td>
                      <td style={{ width: '10%' }}>
                        <div className="f12-500 mb-3">User ID</div>
                        <div className="f12-400 mt-2">n/a</div>
                      </td>
                      <td style={{ width: '18%' }}>
                        <div className="f12-500 mb-3">
                          Last Activity Date & Time
                        </div>
                        <div className="f12-400 mt-2">
                          {moment(props?.data?.updatedAt).format('Do MMM YY,')}{' '}
                          {moment(props?.data?.updatedAt).format('hh:mm:A')}
                        </div>
                      </td>
                      <td style={{ width: '18%' }}>
                        <div className="f12-500 mb-3">Call To Action</div>
                        <div className="f12-400 mt-2">
                          {props?.data?.callToAction == 'RESTAURANT_PAGE'
                            ? 'Restaurant Page'
                            : 'Experience Booking Page'}
                        </div>
                      </td>
                      <td style={{ width: '18%' }}>
                        <div className="f12-500 mb-3">Date & Time</div>
                        <div className="f12-400 mt-2">
                          {moment(props?.data?.createdAt).format('Do MMM YY,')}{' '}
                          {moment(props?.data?.createdAt).format('hh:mm:A')}
                        </div>
                      </td>
                      <td style={{ width: '25%' }}>
                        <div
                          className="f12-500 mb-3"
                          style={{ color: '#ee3a23' }}
                        >
                          More Details
                        </div>
                        <div className="f12-400 d-flex">
                          <ViewShortVideo data={props?.data} />
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={() =>
                              history.push({
                                pathname: `/superadmin/short-videos/edit/${props?.data?._id}`,
                                state: {
                                  edit: true,
                                  data: props?.data,
                                },
                              })
                            }
                          >
                            <Image
                              src={require('../../../../../assets/images/UserManagement/pencil.svg')}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                          <SuperAdminDeleteShortvideo
                            onSuccess={props.onArchive && props.onArchive}
                            id={props?.data?._id}
                            status={props?.data?.archive}
                          />
                          <ShareLinkModal
                            userAppLink={
                              props?.data?.shareLink?.shortLink || ''
                            }
                            webAppLink={''}
                            webAppHide={true}
                          />
                        </div>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
      <React.Fragment></React.Fragment>
    </Fragment>
  );
};

const ViewShortVideo = (props) => {
  const [showView, setShowView] = useState(false);

  const handleshowViewShort = () => {
    setShowView(true);
  };

  const handlecloseView = () => {
    setShowView(false);
  };

  return (
    <>
      <React.Fragment>
        <Button
          variant="link"
          className="enIconBtn mr-3"
          onClick={handleshowViewShort}
        >
          <Image
            src={require('../../../../../assets/images/UserManagement/eye.svg')}
            alt="view short"
            title="view short"
            fluid
          />
        </Button>
        <Modal show={showView} onHide={handlecloseView} centered>
          <Modal.Header
            className="py-0 pt-2 border-0"
            closeButton
          ></Modal.Header>
          <Modal.Body className="f16-500">
            <div className="row m-3">
              <div className="col-5">
                <video width="100%" height="100%" controls>
                  <source src={props?.data?.videoUrl} type="video/mp4" />
                </video>
              </div>
              <div className="col-7">
                <div
                  className="f12-500 text-grey my-1"
                  style={{ wordWrap: 'break-word' }}
                >
                  {props?.data?.description || ''}
                </div>
                <div className="f12-400 mt-2 my-1">
                  {moment(props?.data?.createdAt).format('Do MMM YY,')}{' '}
                  {moment(props?.data?.createdAt).format('hh:mm:A')}
                </div>
                <div className="f12-400 my-1">ID: {props?.data?._id || ''}</div>
                <div>
                  <ul
                    type="none"
                    className={'enStatusList'}
                    style={{ justifyContent: 'left' }}
                  >
                    <li
                      style={{ width: '30%', fontSize: '14px' }}
                      className="d-flex"
                    >
                      <Image
                        src={require('../../../../../assets/images/UserManagement/hearticon.svg')}
                        alt="view short"
                        title="view short"
                        fluid
                        width="20px"
                      />
                      {props?.data?.likes || 0}
                    </li>
                    <li style={{ width: '30%', fontSize: '14px' }}>
                      <Image
                        src={require('../../../../../assets/images/UserManagement/shareicon.svg')}
                        alt="view short"
                        title="view short"
                        fluid
                        width="20px"
                      />
                      {props?.data?.shares || 0}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    </>
  );
};
